/**
 * Whether two Docubird account ids ("{oid}.{tid}") name the same account. GUIDs: the case can
 * differ between sources, so they compare case-insensitively, as every account check must. False
 * when either is missing.
 */
export const sameAccountId = (a: string | null | undefined, b: string | null | undefined): boolean =>
    !!a && !!b && a.toLowerCase() === b.toLowerCase();
